import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import Gallery from "./pages/Gallery/Gallery";
import ProdServices from "./pages/Products/ProdServices.jsx";
import Layout from "./components/Layout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/product-service" element={<ProdServices />} />
          <Route path="/gallery/:listId" element={<Gallery />} />
        </Route>
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
